// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"14673297","732":"f92f6c19","977":"fba7a046"}[chunkId] + ".chunk.js";
};